export enum ObjectState {
  Original = 0,
  Added = 1,
  Deleted = 2,
}
